import STORE from '../STORE';
import CurrentUser from '@/orm/models/CurrentUser';
import { API } from '@/utils/api';
import Alert from '@/orm/models/Alert';

const { actions } = STORE.modules.currentUser;
const { mutations: rootMutations } = STORE;

export default {
  namespaced: true,
  actions: {
    [actions.setCurrentUser]: async ({ commit, rootState }, user) => {
      localStorage.setItem('user', JSON.stringify(user));
      await CurrentUser.create({ data: user });
      if (user.groups.length && !Object.keys(rootState.currentGroup).length) {
        commit(
          `${ rootMutations.setCurrentGroup }`,
          user.groups[0],
          { root: true },
        );
      }
    },
    [actions.getCurrentUser]: async () => {
      const user = await CurrentUser.$fetch();
      await CurrentUser.dispatch(actions.setCurrentUser, user);
    },
    [actions.login]: async ({ dispatch }, { username, password }) => {
      try {
        await API.post('/auth/login/', { username, password });
        await dispatch(actions.getCurrentUser);
      } catch (e) {

        let message = 'Не получилось войти';
        let errorTip = '';

        if (e.response) {
          if (e.response.status >= 400 && e.response.status <= 499) {
            if (e.response.data && typeof e.response.data.non_field_errors === 'object') {
              errorTip = e.response.data.non_field_errors.join('\n');
            }
          }

          if (e.response.status >= 500) {
            message = 'Ошибка сервера';
            errorTip = `${e.response.status} ${e.response.statusText}`;
          }

        }

        await Alert.create({
          data: {
            message: message,
            errorTip: errorTip,
            error: true,
          },
        });
      }
    },
    [actions.logout]: async () => {
      await API.post('/auth/logout/');
      await CurrentUser.deleteAll();
      localStorage.removeItem('user');
    },
  },
};
